<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fFfh5u/tc-custom/9781398414860.jpg?1745521203815" alt="This image is the cover for the book Will Power"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Will Power
      </h1>
      <p class="bookDescription body article font2">
        <p>He is universally regarded as the world’s most influential writer, whose works transcend cultures and time. Yet, in his homeland, one person in five has never seen or read a play by William Shakespeare. The author of this book believes the reason that so many fail to make the acquaintance of the Bard lies in the classroom. He feels the introduction to Shakespeare is made in the wrong way and to pupils of the wrong age. This book attempts to show that simple rhymes, evoking the powerful moral themes of Shakespearean drama, can engage the interest of young children more effectively than confronting teenagers with an incomprehensible text.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gordon
      </h2>
      
      <p class="authorDescription body article">John Gordon grew up on a council estate in Ipswich and attended grammar school. He likes to claim that his higher education was provided by the National Assistance Board, Hammersmith, where he started work aged 18, at the beginning of a career in the Civil Service that lasted 35 years. He went on to work as a journalist, broadcaster and benefits advisor. He started writing poetry for children to utilise the spare time he acquired when he became afflicted with a crippling spinal condition.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07b31d80